/* Catalogue des parfums Arlequin. */

export const FLAVORS_GLACES = [
    { name: "Pistache", img: "/images/scoop-pistache.png" },
    { name: "Vanille", img: "/images/scoop-vanille.png" },
    { name: "Stracciatella", img: "/images/scoop-stracciatella.png" },
    { name: "Noisette", img: "/images/scoop-noisette.png" },
    { name: "Café", img: "/images/scoop-cafe.png" },
    { name: "Nougat", img: "/images/scoop-nougat.png" },
    { name: "Menthe / chocolat", img: "/images/scoop-menthe-chocolat.png" },
    { name: "Coco antillais", img: "/images/scoop-coco.png" },
    { name: "Yaourt fermier", img: "/images/scoop-yaourt.png" },
    { name: "Caramel fleur de sel", img: "/images/scoop-caramel.png" },
];

export const FLAVORS_SORBETS = [
    { name: "Chocolat noir 64 %", img: "/images/scoop-chocolat.png" },
    { name: "Fraise", img: "/images/scoop-fraise.png" },
    { name: "Pomme verte / noisette", img: "/images/scoop-pomme.png" },
    { name: "Citron / basilic", img: "/images/scoop-citron.png" },
    { name: "Mangue / passion", img: "/images/scoop-mangue.png" },
    { name: "Litchi / framboise", img: "/images/scoop-litchi.png" },
    { name: "Poire / sauce chocolat", img: "/images/scoop-poire.png" },
    { name: "Cassis", img: "/images/scoop-cassis.png" },
    { name: "Pêche de vigne", img: "/images/scoop-peche.png" },
    { name: "Figue violette", img: "/images/scoop-figue.png" },
];
